/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { ValueType } from 'hems/common/utils';
/** 권한별 UI 기능 리스트 테이블 https://growingenergylabs.atlassian.net/wiki/x/wQE14wE */

export const ROLE_NAME = {
  USER: 'user',
  INSTALLER: 'installer',
  DEV: 'dev',
  SERVICE: 'service',
  ADMIN: 'admin',
} as const;

export type RoleNameValue = ValueType<typeof ROLE_NAME>;

export const ROLE_CODE = {
  USER: '10',
  INSTALLER: '20',
  DEV: '60',
  SERVICE: '70',
  ADMIN: '90',
} as const;

export type RoleCodeValue = ValueType<typeof ROLE_CODE>;

// 참고 문서: Role Matrix - https://growingenergylabs.atlassian.net/wiki/x/AgDJSAI
export const FLEET_ROLE = {
  /** DEV */
  DEVOPS: 'DevOps',
  /** DEV */
  QCELLS_SUPER_ADMIN: 'Qcells Super Admin',
  /** DEV */
  QCELLS_ADMIN: 'Qcells Admin',
  /** Admin */
  QCELLS_MANAGER: 'Qcells Manager',
  /** Service */
  QCELLS_VIEWER: 'Qcells Viewer',
  /** Installer */
  VPP_PARTNER_ADMIN: 'VPP Partner Admin',
  /** Installer */
  VPP_MANAGER: 'VPP Manager',
  /** Installer */
  VPP_VIEWER: 'VPP Viewer',
  /** Installer */
  FLEET_PARTNER_ADMIN: 'Fleet Partner Admin',
  /** Installer */
  FLEET_MANAGER: 'Fleet Manager',
  /** Installer */
  FLEET_VIEWER: 'Fleet Viewer',
} as const;

export type FleetRoleValue = ValueType<typeof FLEET_ROLE>;

export const AUTH_TYPE_CODE_BY_FLEET_ROLE: Record<FleetRoleValue, RoleCodeValue> = {
  [FLEET_ROLE.DEVOPS]: ROLE_CODE.ADMIN,
  [FLEET_ROLE.QCELLS_SUPER_ADMIN]: ROLE_CODE.ADMIN,
  [FLEET_ROLE.QCELLS_ADMIN]: ROLE_CODE.ADMIN,
  [FLEET_ROLE.QCELLS_MANAGER]: ROLE_CODE.ADMIN,
  [FLEET_ROLE.QCELLS_VIEWER]: ROLE_CODE.SERVICE,
  [FLEET_ROLE.VPP_PARTNER_ADMIN]: ROLE_CODE.INSTALLER,
  [FLEET_ROLE.VPP_MANAGER]: ROLE_CODE.INSTALLER,
  [FLEET_ROLE.VPP_VIEWER]: ROLE_CODE.INSTALLER,
  [FLEET_ROLE.FLEET_PARTNER_ADMIN]: ROLE_CODE.INSTALLER,
  [FLEET_ROLE.FLEET_MANAGER]: ROLE_CODE.INSTALLER,
  [FLEET_ROLE.FLEET_VIEWER]: ROLE_CODE.INSTALLER,
} as const;
